import { useState } from 'react';
const useFallbackState = (defaultValue, state) => {
    const _state = useState(defaultValue);
    if (state) {
        return state;
    }
    return _state;
};
export default useFallbackState;
//# sourceMappingURL=useFallbackState.js.map